import { BLOCKS, INLINES, Node } from "@contentful/rich-text-types"
import React, { ReactNode } from "react"
import styled from "styled-components"
import { resolveIsEmail } from "../../../contentful/options/rich-text"
import RichText from "../../../resolvers/rich-text/rich-text.resolver"
import { AppFunctionComponent, ContentfulSection } from "../../../types"
import { TextLink } from "../../../ui/components/link/link.component"
import { smallBodyTextStyles } from "../../common/general-styles.component"

const SectionHeading = styled.h6`
  ${smallBodyTextStyles};
  margin-bottom: 3px;
  line-height: 1.5em;
`

const AddressBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 10px;
  ${SectionHeading} {
    margin-bottom: 15px;
    margin-top: 50px;
  }
`

const AddressText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 2.3em;
  white-space: pre-wrap;
`

type Props = {
  element: ContentfulSection
}

const ContactData: AppFunctionComponent<Props> = ({ element }) => (
  <>
    {element.text && (
      <RichText
        content={element.text}
        options={{
          [BLOCKS.EMBEDDED_ENTRY]: (node: Node) => {
            const { text, slug } = node.data.target
            switch (slug) {
              case "about-contact-emails":
                return (
                  <div>
                    <RichText
                      content={text}
                      options={{
                        [BLOCKS.HEADING_6]: (_, children: ReactNode) => (
                          <SectionHeading>{children}</SectionHeading>
                        ),
                        [INLINES.HYPERLINK]: (
                          linkNode: Node,
                          children: ReactNode
                        ) => (
                          <TextLink to={resolveIsEmail(linkNode.data.uri)}>
                            {children}
                          </TextLink>
                        ),
                      }}
                    />
                  </div>
                )
              case "about-contact-address":
                return (
                  <AddressBox>
                    {
                      <RichText
                        content={text}
                        options={{
                          [BLOCKS.HEADING_6]: (_, children: ReactNode) => (
                            <SectionHeading>{children}</SectionHeading>
                          ),
                          [BLOCKS.PARAGRAPH]: (_, children: ReactNode) => (
                            <AddressText>{children}</AddressText>
                          ),
                        }}
                      />
                    }
                  </AddressBox>
                )
              default:
                return
            }
          },
        }}
      />
    )}
  </>
)

export default ContactData
